import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import StoreRoutes from './themes/store/routes';
import DashboardRoutes from './dashboard/routes';
import Login from './pages/Login';
import Register from './pages/Register';
import Onboarding from './pages/Onboarding';
import PublicOrder from './pages/PublicOrder';
import LandingPage from './pages/LandingPage';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout/Layout';
import SellerReviews from './pages/reviews/SellerReviews';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/onboarding" element={
        <PrivateRoute>
          <Onboarding />
        </PrivateRoute>
      } />
      <Route path="/public/order/:orderId" element={<PublicOrder />} />
      <Route path="/reviews/:sellerId" element={<SellerReviews />} />
      
      {/* Dashboard Routes - requer autenticação */}
      <Route path="/dashboard/*" element={
        <PrivateRoute>
          <Layout>
            <DashboardRoutes />
          </Layout>
        </PrivateRoute>
      } />
      
      {/* Store Routes - acessível publicamente */}
      <Route path="/shop/:storeSlug/*" element={<StoreRoutes />} />
    </Routes>
  );
}
